import React from 'react';
import propTypes from 'prop-types';
import '../global-sass/main.scss';

const EventDescription = ({ children, className }) => {
	if (!children) return null;
	// Check if children is a string
	const isString = typeof children === 'string';
	// Process HTML string to convert newlines to <br> tags
	const processedHtml = isString ? children.replace(/\n/g, '<br />') : '';
	return (
		<div
			className={`${className} event-description`}
			data-testid="event-description"
			dangerouslySetInnerHTML={{
				__html: processedHtml
			}}
		/>
	);
};

export default EventDescription;

const EventDescriptionProp = {
	className: propTypes.string,
	children: propTypes.node.isRequired
};

EventDescription.propTypes = EventDescriptionProp;
